export default "__VITE_ASSET__89ac6291__"